export default {
  approvalFiles: () => require('./configCamposFiltrosApprovalFiles').default,
  files: () => require('./configuracionCamposFiltrosDnt').default
};
